import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { scaffolderTranslationRef } from '@backstage/plugin-scaffolder/alpha';

export const scaffolderTranslation = TranslationBlueprint.make({
  name: 'scaffolder',
  params: {
    resource: createTranslationMessages({
      ref: scaffolderTranslationRef,
      full: false,
      messages: {
        'aboutCard.launchTemplate': 'Start template',
        'actionsPage.title': 'Geïnstalleerde acties',
        'actionsPage.pageTitle': 'Aan de slag',
        'actionsPage.subtitle': 'Alle geïnstalleerde acties',
        'actionsPage.content.emptyState.title': 'Geen informatie om te tonen',
        'actionsPage.content.emptyState.description':
          'Er zijn geen acties geïnstalleerd, of de communicatie met de backend is mislukt.',
        'actionsPage.content.searchFieldPlaceholder': 'Zoek een actie',
        'actionsPage.action.input': 'Invoer',
        'actionsPage.action.output': 'Uitvoer',
        'actionsPage.action.examples': 'Voorbeelden',
        'fields.entityNamePicker.title': 'Naam',
        'fields.entityNamePicker.description': 'Unieke naam van het component',
        'fields.entityPicker.title': 'Entiteit',
        'fields.entityPicker.description': 'Een entiteit uit de catalogus',
        'fields.entityTagsPicker.title': 'Tags',
        'fields.entityTagsPicker.description':
          'Voeg relevante tags toe en druk op Enter om een nieuwe tag toe te voegen. Geldig formaat: [a-z0-9+#] gescheiden door [-], maximaal 63 tekens',
        'fields.multiEntityPicker.title': 'Entiteit',
        'fields.multiEntityPicker.description': 'Een entiteit uit de catalogus',
        'fields.myGroupsPicker.title': 'Entiteit',
        'fields.myGroupsPicker.description': 'Een entiteit uit de catalogus',
        'fields.ownedEntityPicker.title': 'Entiteit',
        'fields.ownedEntityPicker.description': 'Een entiteit uit de catalogus',
        'fields.ownerPicker.title': 'Eigenaar',
        'fields.ownerPicker.description': 'De eigenaar van het component',
        'fields.azureRepoPicker.organization.title': 'Organisatie',
        'fields.azureRepoPicker.organization.description':
          'De organisatie waartoe deze repository gaat behoren',
        'fields.azureRepoPicker.project.title': 'Project',
        'fields.azureRepoPicker.project.description':
          'Het project waartoe deze repository gaat behoren',
        'fields.bitbucketRepoPicker.workspaces.title': 'Toegestane workspaces',
        'fields.bitbucketRepoPicker.workspaces.inputTitle': 'Workspaces',
        'fields.bitbucketRepoPicker.workspaces.description':
          'De workspace waartoe deze repository gaat behoren',
        'fields.bitbucketRepoPicker.project.title': 'Toegestane projecten',
        'fields.bitbucketRepoPicker.project.inputTitle': 'Projecten',
        'fields.bitbucketRepoPicker.project.description':
          'Het project waartoe deze repository gaat behoren',
        'fields.gerritRepoPicker.owner.title': 'Eigenaar',
        'fields.gerritRepoPicker.owner.description':
          'De eigenaar van het project (optioneel)',
        'fields.gerritRepoPicker.parent.title': 'Bovenliggend project',
        'fields.gerritRepoPicker.parent.description':
          'Het bovenliggende project waartoe deze repository gaat behoren',
        'fields.giteaRepoPicker.owner.title': 'Beschikbare eigenaren',
        'fields.giteaRepoPicker.owner.inputTitle': 'Eigenaar',
        'fields.giteaRepoPicker.owner.description':
          'Gitea-namespace waartoe deze repository gaat behoren. Dit kan de naam zijn van een organisatie, groep, subgroep, gebruiker of project.',
        'fields.githubRepoPicker.owner.title': 'Beschikbare eigenaren',
        'fields.githubRepoPicker.owner.inputTitle': 'Eigenaar',
        'fields.githubRepoPicker.owner.description':
          'De organisatie, gebruiker of het project waartoe deze repository gaat behoren',
        'fields.gitlabRepoPicker.owner.title': 'Beschikbare eigenaren',
        'fields.gitlabRepoPicker.owner.inputTitle': 'Eigenaar',
        'fields.gitlabRepoPicker.owner.description':
          'GitLab-namespace waartoe deze repository gaat behoren. Dit kan de naam zijn van een organisatie, groep, subgroep, gebruiker of project.',
        'fields.repoUrlPicker.host.title': 'Host',
        'fields.repoUrlPicker.host.description':
          'De host waarop de repository wordt aangemaakt',
        'fields.repoUrlPicker.repository.title': 'Beschikbare repositories',
        'fields.repoUrlPicker.repository.inputTitle': 'Repository',
        'fields.repoUrlPicker.repository.description':
          'De naam van de repository',
        'fields.repoOwnerPicker.title': 'Eigenaar',
        'fields.repoOwnerPicker.description': 'De eigenaar van de repository',
        'listTaskPage.title': 'Taken van templates',
        'listTaskPage.pageTitle': 'Taken van templates',
        'listTaskPage.subtitle': 'Alle gestarte taken',
        'listTaskPage.content.emptyState.title': 'Geen informatie om te tonen',
        'listTaskPage.content.emptyState.description':
          'Er zijn geen taken, of de communicatie met de backend is mislukt.',
        'listTaskPage.content.tableTitle': 'Taken',
        'listTaskPage.content.tableCell.taskID': 'Taak-ID',
        'listTaskPage.content.tableCell.template': 'Template',
        'listTaskPage.content.tableCell.created': 'Aangemaakt',
        'listTaskPage.content.tableCell.owner': 'Eigenaar',
        'listTaskPage.content.tableCell.status': 'Status',
        'ownerListPicker.title': 'Eigenaar van taak',
        'ownerListPicker.options.owned': 'Van mij',
        'ownerListPicker.options.all': 'Alle',
        'ongoingTask.title': 'Uitvoering van',
        'ongoingTask.pageTitle.hasTemplateName':
          'Uitvoering van {{templateName}}',
        'ongoingTask.pageTitle.noTemplateName': 'Uitvoering van template',
        'ongoingTask.subtitle': 'Taak {{taskId}}',
        'ongoingTask.cancelButtonTitle': 'Annuleer',
        'ongoingTask.retryButtonTitle': 'Probeer opnieuw',
        'ongoingTask.startOverButtonTitle': 'Begin opnieuw',
        'ongoingTask.hideLogsButtonTitle': 'Verberg logs',
        'ongoingTask.showLogsButtonTitle': 'Toon logs',
        'ongoingTask.contextMenu.moreOptions': 'Meer opties',
        'ongoingTask.contextMenu.hideLogs': 'Verberg logs',
        'ongoingTask.contextMenu.showLogs': 'Toon logs',
        'ongoingTask.contextMenu.hideButtonBar': 'Verberg knoppenbalk',
        'ongoingTask.contextMenu.retry': 'Probeer opnieuw',
        'ongoingTask.contextMenu.showButtonBar': 'Toon knoppenbalk',
        'ongoingTask.contextMenu.startOver': 'Begin opnieuw',
        'ongoingTask.contextMenu.cancel': 'Annuleer',
        'templateEditorForm.stepper.emptyText':
          'De template heeft geen spec-parameters om te bekijken.',
        'renderSchema.tableCell.name': 'Naam',
        'renderSchema.tableCell.title': 'Titel',
        'renderSchema.tableCell.description': 'Beschrijving',
        'renderSchema.tableCell.type': 'Type',
        'renderSchema.tableCell.value': 'Waarde',
        'renderSchema.undefined': 'Geen schema gedefinieerd',
        'templatingExtensions.title': 'Template-extensies',
        'templatingExtensions.pageTitle': 'Template-extensies',
        'templatingExtensions.subtitle': 'Alle beschikbare template-extensies',
        'templatingExtensions.content.emptyState.title':
          'Geen informatie om te tonen',
        'templatingExtensions.content.emptyState.description':
          'Er zijn geen template-extensies beschikbaar, of de communicatie met de backend is mislukt.',
        'templatingExtensions.content.searchFieldPlaceholder':
          'Zoek een extensie',
        'templatingExtensions.content.filters.title': 'Filters',
        'templatingExtensions.content.filters.notAvailable':
          'Er zijn geen templatefilters gedefinieerd.',
        'templatingExtensions.content.filters.metadataAbsent':
          'Metadata van filter niet beschikbaar',
        'templatingExtensions.content.filters.schema.input': 'Invoer',
        'templatingExtensions.content.filters.schema.arguments': 'Argumenten',
        'templatingExtensions.content.filters.schema.output': 'Uitvoer',
        'templatingExtensions.content.filters.examples': 'Voorbeelden',
        'templatingExtensions.content.functions.title': 'Functies',
        'templatingExtensions.content.functions.notAvailable':
          'Er zijn geen globale templatefuncties gedefinieerd.',
        'templatingExtensions.content.functions.metadataAbsent':
          'Metadata van functie niet beschikbaar',
        'templatingExtensions.content.functions.schema.arguments': 'Argumenten',
        'templatingExtensions.content.functions.schema.output': 'Uitvoer',
        'templatingExtensions.content.functions.examples': 'Voorbeelden',
        'templatingExtensions.content.values.title': 'Waarden',
        'templatingExtensions.content.values.notAvailable':
          'Er zijn geen globale templatewaarden gedefinieerd.',
        'templateTypePicker.title': 'Categorieën',
        'templateIntroPage.title': 'Beheer templates',
        'templateIntroPage.subtitle':
          'Bewerk en bekijk templates, formulieren en aangepaste velden, en probeer ze uit',
        'templateFormPage.title': 'Template-editor',
        'templateFormPage.subtitle':
          'Bewerk en bekijk templateformulieren, en probeer ze uit',
        'templateCustomFieldPage.title': 'Verkenner voor aangepaste velden',
        'templateCustomFieldPage.subtitle':
          'Bewerk en bekijk aangepaste velden, en probeer ze uit',
        'templateEditorPage.title': 'Template-editor',
        'templateEditorPage.subtitle':
          'Bewerk en bekijk templates en templateformulieren, en probeer ze uit',
        'templateEditorPage.dryRunResults.title': 'Resultaten van proefrun',
        'templateEditorPage.dryRunResultsList.title': 'Resultaat {{resultId}}',
        'templateEditorPage.dryRunResultsList.downloadButtonTitle':
          'Download als .zip',
        'templateEditorPage.dryRunResultsList.deleteButtonTitle':
          'Verwijder resultaat',
        'templateEditorPage.dryRunResultsView.tab.files': 'Bestanden',
        'templateEditorPage.dryRunResultsView.tab.log': 'Log',
        'templateEditorPage.dryRunResultsView.tab.output': 'Uitvoer',
        'templateEditorPage.taskStatusStepper.skippedStepTitle': 'Overgeslagen',
        'templateEditorPage.customFieldExplorer.selectFieldLabel':
          'Kies een extensie voor een aangepast veld',
        'templateEditorPage.customFieldExplorer.fieldForm.title': 'Veldopties',
        'templateEditorPage.customFieldExplorer.fieldForm.applyButtonTitle':
          'Pas toe',
        'templateEditorPage.customFieldExplorer.fieldPreview.title':
          'Voorbeeld van veld',
        'templateEditorPage.customFieldExplorer.preview.title':
          'Specificatie van template',
        'templateEditorPage.templateEditorBrowser.closeConfirmMessage':
          'Weet je het zeker? Niet-bewaarde wijzigingen gaan verloren.',
        'templateEditorPage.templateEditorBrowser.saveIconTooltip':
          'Bewaar alle bestanden',
        'templateEditorPage.templateEditorBrowser.reloadIconTooltip':
          'Laad map opnieuw',
        'templateEditorPage.templateEditorBrowser.closeIconTooltip':
          'Sluit map',
        'templateEditorPage.templateEditorIntro.title':
          'Begin met een van de onderstaande opties',
        'templateEditorPage.templateEditorIntro.loadLocal.title':
          'Laad templatemap',
        'templateEditorPage.templateEditorIntro.loadLocal.description':
          'Laad een lokale templatemap, zodat je je eigen template kunt bewerken en uitproberen.',
        'templateEditorPage.templateEditorIntro.loadLocal.unsupportedTooltip':
          'Werkt alleen in sommige Chromium-browsers, en alleen als de pagina via HTTPS is geladen',
        'templateEditorPage.templateEditorIntro.createLocal.title':
          'Maak nieuwe template',
        'templateEditorPage.templateEditorIntro.createLocal.description':
          'Maak een lokale templatemap, zodat je je eigen template kunt bewerken en uitproberen.',
        'templateEditorPage.templateEditorIntro.createLocal.unsupportedTooltip':
          'Werkt alleen in sommige Chromium-browsers, en alleen als de pagina via HTTPS is geladen',
        'templateEditorPage.templateEditorIntro.formEditor.title':
          'Oefenomgeving voor templateformulieren',
        'templateEditorPage.templateEditorIntro.formEditor.description':
          'Bekijk en bewerk een templateformulier, met een voorbeeldtemplate of een template uit de catalogus.',
        'templateEditorPage.templateEditorIntro.fieldExplorer.title':
          'Verkenner voor aangepaste velden',
        'templateEditorPage.templateEditorIntro.fieldExplorer.description':
          'Bekijk de geïnstalleerde extensies voor aangepaste velden en probeer ze uit.',
        'templateEditorPage.templateEditorTextArea.saveIconTooltip':
          'Bewaar bestand',
        'templateEditorPage.templateEditorTextArea.refreshIconTooltip':
          'Laad bestand opnieuw',
        'templateEditorPage.templateEditorTextArea.emptyStateParagraph':
          'Kies een actie in het bestandsmenu.',
        'templateEditorPage.templateFormPreviewer.title':
          'Laad bestaande template',
        'templateListPage.title': 'Aan de slag',
        'templateListPage.subtitle':
          'Maak nieuwe softwarecomponenten met de standaardtemplates van je organisatie',
        'templateListPage.pageTitle': 'Aan de slag',
        'templateListPage.templateGroups.defaultTitle': 'Templates',
        'templateListPage.templateGroups.otherTitle': 'Andere templates',
        'templateListPage.contentHeader.registerExistingButtonTitle':
          'Registreer bestaand component',
        'templateListPage.contentHeader.supportButtonTitle':
          'Maak nieuwe softwarecomponenten met standaardtemplates. Verschillende templates maken verschillende soorten componenten (services, websites, documentatie en meer).',
        'templateListPage.additionalLinksForEntity.viewTechDocsTitle':
          'Documentatie bekijken',
        'templateWizardPage.title': 'Aan de slag',
        'templateWizardPage.subtitle':
          'Maak nieuwe softwarecomponenten met de standaardtemplates van je organisatie',
        'templateWizardPage.pageTitle': 'Aan de slag',
        'templateWizardPage.templateWithTitle':
          'Aan de slag: {{templateTitle}}',
        'templateWizardPage.pageContextMenu.editConfigurationTitle':
          'Bewerk configuratie',
        'templateEditorToolbar.customFieldExplorerTooltip':
          'Verkenner voor aangepaste velden',
        'templateEditorToolbar.installedActionsDocumentationTooltip':
          'Documentatie van geïnstalleerde acties',
        'templateEditorToolbar.templatingExtensionsDocumentationTooltip':
          'Documentatie van template-extensies',
        'templateEditorToolbar.addToCatalogButton': 'Publiceer',
        'templateEditorToolbar.addToCatalogDialogTitle':
          'Publiceer wijzigingen',
        'templateEditorToolbar.addToCatalogDialogContent.stepsIntroduction':
          'Volg de onderstaande stappen om een template te maken of bij te werken:',
        'templateEditorToolbar.addToCatalogDialogContent.stepsListItems':
          'Bewaar de templatebestanden in een lokale map\nMaak een pull request aan op een nieuwe of bestaande git-repository\nBestaat de template al, dan verschijnen de wijzigingen in de softwarecatalogus zodra de pull request is samengevoegd\nMaak je een nieuwe template, volg dan de onderstaande documentatie om de nieuwe templaterepository te registreren in de softwarecatalogus',
        'templateEditorToolbar.addToCatalogDialogActions.documentationButton':
          'Naar de documentatie',
        'templateEditorToolbarFileMenu.button': 'Bestand',
        'templateEditorToolbarFileMenu.options.openDirectory':
          'Open templatemap',
        'templateEditorToolbarFileMenu.options.createDirectory':
          'Maak templatemap',
        'templateEditorToolbarFileMenu.options.closeEditor':
          'Sluit template-editor',
        'templateEditorToolbarTemplatesMenu.button': 'Templates',
        'featuredTemplatesWidget.scrollPreviousButtonTitle': 'Vorige templates',
        'featuredTemplatesWidget.scrollNextButtonTitle': 'Volgende templates',
        'featuredTemplatesWidget.errorMessage':
          'De templates konden niet worden geladen.',
        'featuredTemplatesWidget.errorRetryButtonTitle': 'Probeer opnieuw',
        'featuredTemplatesWidget.emptyMessage':
          'Er zijn op dit moment geen templates om te tonen.',
        'featuredTemplatesWidget.emptyBrowseAllButtonTitle':
          'Alle templates bekijken',
      },
    }),
  },
});
